export function calculatePaletteGrip(clientRect: ClientRect, top: number, left: number) {
	const bottom = clientRect.height;
	const right = clientRect.width;

	top = top < 0 ? 0 : top > bottom ? bottom : top;
	left = left < 0 ? 0 : left > right ? right : left;

	const pLeft = Math.round(left / (right / 100));
	const pTop = 100 - Math.round(top / (bottom / 100));

	return {
		s: pLeft / 100,
		v: pTop / 100,
	};
}
export function calculateRangeGrip(clientRect: ClientRect, left: number) {
	const right = clientRect.width;
	left = left < 0 ? 0 : left > right ? right : left;

	return {
		h: Math.round(360 * (left / right)),
		rangeLeft: left,
	};
}
